import { c as _c } from "react/compiler-runtime";
import { useGetBulkDialogContent } from "@components/common/faro-table/bulk-dialog/bulk-dialog-helper";
import { TEAM_DISPLAY_NAME, TEAMS_DISPLAY_NAME } from "@src/constants/team-constants";
import { useAppSelector } from "@store/store-helper";
import { bulkActionResultsSelector, numberOfUpdatingItemsSelector } from "@store/table/table-selector";
import { nounPluralize } from "@utils/data-display";

/**
 * Determines the content of the bulk dialog and the bulk success dialog for
 * removing a member from the selected teams.
 */
export function useRemoveMemberFromTeamsBulkDialogContent() {
  const $ = _c(10);
  const numberOfUpdatingItems = useAppSelector(numberOfUpdatingItemsSelector);
  const {
    numberOfSuccess,
    numberOfErrors
  } = useAppSelector(bulkActionResultsSelector);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      title: `Remove member from these ${TEAMS_DISPLAY_NAME}?`,
      description: `When you confirm this action, the member will lose access to all
       projects these ${TEAMS_DISPLAY_NAME} are part of, and will lose the workspace
       roles assigned to these ${TEAMS_DISPLAY_NAME}.`
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = `Couldn't remove member from ${numberOfErrors} of ${numberOfUpdatingItems} ${TEAMS_DISPLAY_NAME}`;
  let t2;
  if ($[1] !== t1) {
    t2 = {
      initial: t0,
      failed: {
        title: t1,
        description: `The member couldn't be removed from these ${TEAMS_DISPLAY_NAME}, check the details and try again.`
      },
      confirmButtonText: "remove",
      entityType: TEAM_DISPLAY_NAME
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const bulkDialogContent = useGetBulkDialogContent(t2);
  let t3;
  if ($[3] !== numberOfSuccess) {
    t3 = nounPluralize({
      counter: numberOfSuccess,
      word: TEAM_DISPLAY_NAME
    });
    $[3] = numberOfSuccess;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `The member has been removed from ${t3}`;
  let t5;
  if ($[5] !== t4) {
    t5 = {
      title: "Member removed",
      description: t4
    };
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const successDialogContent = t5;
  let t6;
  if ($[7] !== bulkDialogContent || $[8] !== successDialogContent) {
    t6 = {
      bulkDialogContent,
      successDialogContent
    };
    $[7] = bulkDialogContent;
    $[8] = successDialogContent;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}